import React, {Component} from 'react';
import { Slide } from 'react-slideshow-image';
import './ImageShow.css';
import {isMobileOnly, isMobile} from 'react-device-detect';
import fire from './fire'

const barWidth = () => {
  if (isMobile) return 100
  else return 70
}
   
const properties = {
    duration: 10000,
    transitionDuration: 300,
    infinite: true,
    indicators: false,
    arrows: false,
}
   
class Topnavi extends Component {
    constructor() {
      super();
      this.state = {
        items: []
      }
    }
    
    customHeight1 = () => {
      const renderHeight = barWidth() / 2.9 
      if (isMobileOnly) return `${renderHeight + 2}vw`
      else return `${renderHeight / 2 + 1}vw`
    }

    customHeight2 = () => {
      const renderHeight = barWidth() / 2.9
      if (isMobileOnly) return `${renderHeight}vw`
      else return `${renderHeight / 2}vw`
    }

    componentDidMount() {
      const itemsRef = fire.database().ref('Ads');
      itemsRef.once('value', (snapshot) => {
        let items = snapshot.val();
        let newState = [];
        for (let item in items) {
          newState.push({
            Image: items[item].ImageLink,
            Link: items[item].promoLink
          });
        }
        this.setState({
          items: newState
        });
      });
    }

    getPromoLink = (arg) =>{
      if (arg) return arg
      else return false
    }

    render() {
      return (
        <div className ="container-Style" style={{height: this.customHeight1()}}>
          <div className="slide-container" style ={{width: `${barWidth()}vw` , height: this.customHeight2()}}>
            <Slide {...properties}>
            { this.state.items.map(item =>
              <a    
                  style ={{color:"inherit", display:"inherit"}}
                  href= {this.getPromoLink(item.Link)}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={this.getPromoLink(item.Link)}
                >
                 <div className={"each-slide"} style={{height: this.customHeight2()}}>
                
                  <div style={{'backgroundImage': `url(${item.Image})` , height: this.customHeight2()}} />
                 
              </div>
              </a>
            )}
            </Slide>
          </div>
        </div>
      );
    }
  }

  export default Topnavi;